(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gs-hero"]) return;
  try {
    
$('.slider_wrap').slick({
infinite: true,
speed: 2000,
slidesToShow: 1,
slidesToScroll: 1 
});

  } catch(e) { console.error(e); }
})();
})();
